export const TABLEAU_LIBRARY_ITEM_TYPES = {
  TableauReport: 700,
  TableauReportPage: 701,
};

export const isTableauLibraryItem = (libraryItemType: number): boolean =>
  Object.values(TABLEAU_LIBRARY_ITEM_TYPES).indexOf(libraryItemType) !== -1;
